import { useQuery } from '@tanstack/vue-query';
import { computed, ref } from 'vue';
import { searchInAllFields } from '@infuse/e-connector/shared/utils';
import { getAllBasicAuthDeviations } from '@infuse/api/e-connector/basic-auth-deviation';
import { BasicAuthDeviation, mapToDomain } from '@infuse/e-connector/basic-auth-deviation/domain';

// e-connector doesn't use umbrella for this api
export const useBasicAuthDeviations = () => {
  const searchQuery = ref<string | undefined>();

  const query = useQuery<BasicAuthDeviation[]>({
    queryKey: ['basic-auth-deviations'],
    queryFn: async () => {
      const response = await getAllBasicAuthDeviations({});
      return response.map((bad) => mapToDomain(bad));
    }
  });

  const basicAuthDeviations = computed(() => searchInAllFields(searchQuery.value || '', query.data.value || []));

  return {
    ...query,
    searchQuery,
    basicAuthDeviations
  };
};
